export type NoteOutlineVisibilityInput = {
  isEditorReady: boolean;
  isOutlineOpen: boolean;
};

export type NoteOutlineVisibilityState = {
  shouldShowOutline: boolean;
  shouldShowPersistentOutline: boolean;
};

export const getNoteOutlineVisibility = ({
  isEditorReady,
  isOutlineOpen,
}: NoteOutlineVisibilityInput): NoteOutlineVisibilityState => {
  const shouldShowPersistentOutline = isEditorReady && isOutlineOpen;

  return {
    shouldShowOutline: shouldShowPersistentOutline,
    shouldShowPersistentOutline,
  };
};
